import { useContext, useMemo } from 'react';
import Cancel from 'assets/svg/Cancel';
import { FilterContextData } from 'contexts/FilterContext';
import styled from '@emotion/styled';
import tw from 'twin.macro';
import { formatString, getConfig } from 'utils/helperMethods';
import { isGlobalFilterEmpty } from 'parser/filterParser';
import FilterExpandAttributeView from './FilterExpandAttributeView';
import { Spin } from 'antd';
import { UserContext } from 'contexts/ConfigContext';
import { trackEventMixpanel } from 'utils/mixpanel';
import { GLOBAL_FILTER_CLICK_INSIDE_EXPANDED_FILTER } from 'utils/mixpanelEventNames';
import { CancelButton } from './SaveSelectionPresetsModal';

interface Props {
    expandFilter: Function;
    allSelectedValueForAllAttribute: any;
    setApplyFilterObject: Function;
    onSaveSelection: Function;
    applyFilterObject: any;
    allAttributeCallLoading: Boolean;
    setAttributeTypeExpandClose: any;
    timeSelectionLabel: any;
    screenFilterConfig: any;
}

function FilterExpand({
    expandFilter,
    allSelectedValueForAllAttribute,
    setApplyFilterObject,
    applyFilterObject,
    allAttributeCallLoading,
    setAttributeTypeExpandClose,
    timeSelectionLabel,
    onSaveSelection,
    screenFilterConfig,
}: Props) {
    const SelectionCapsul = styled.span`
        ${tw`bg-bgBackground p-1.5 rounded text-purpleFont flex w-fit items-center gap-2`}
    `;

    const {
        allCheckedAttribute,
        setAllCheckedAttribute,
        selectedPresetInfoObj,
        hideGlobalTimeFilterComponent,
        attributeTypes,
        setAllSelectedValueForAllAttribute,
        disablePresetFilter,
    } = useContext(FilterContextData);
    const listOfAttrType = attributeTypes;
    const presetNameLabel = selectedPresetInfoObj?.value ? `${selectedPresetInfoObj?.value} is selected` : '';

    //checks if global filter is empty or not
    const isFilterEmpty = useMemo(() => {
        return isGlobalFilterEmpty(allCheckedAttribute);
    }, [allCheckedAttribute]);

    return (
        <div className="bg-white rounded-r-lg drop-shadow-lg -ml-1 z-10 global-filter-width">
            <div className="font-md h-full">
                <div className="flex justify-between items-center mt-4 px-3.2">
                    <span className="font-medium">Selections</span>
                    <span onClick={() => expandFilter()} className="cursor-pointer">
                        <Cancel />
                    </span>
                </div>
                {allAttributeCallLoading ? (
                    <div className="flex w-full h-full justify-center items-center">
                        <span>
                            <Spin />
                        </span>
                    </div>
                ) : (
                    <div
                        onClick={() => {
                            //mixpanel event
                            trackEventMixpanel(GLOBAL_FILTER_CLICK_INSIDE_EXPANDED_FILTER);
                        }}
                    >
                        {!hideGlobalTimeFilterComponent && (
                            <div className="px-3.2 mt-6 flex-col">
                                <div className="mb-4 flex justify-between items-center">
                                    <span className="font-sm font-medium">Time Period</span>
                                </div>
                                <SelectionCapsul className="font-xs">
                                    {timeSelectionLabel.toUpperCase()}
                                </SelectionCapsul>
                            </div>
                        )}
                        <FilterExpandAttributeView
                            screenFilterConfig={screenFilterConfig}
                            attributeTypes={attributeTypes}
                            allCheckedAttribute={allCheckedAttribute}
                            setAllCheckedAttribute={setAllCheckedAttribute}
                            setApplyFilterObject={setApplyFilterObject}
                            applyFilterObject={applyFilterObject}
                            allSelectedValueForAllAttribute={allSelectedValueForAllAttribute}
                            setAllSelectedValueForAllAttribute={setAllSelectedValueForAllAttribute}
                            listOfAttrType={listOfAttrType}
                            setAttributeTypeExpandClose={setAttributeTypeExpandClose}
                        />
                    </div>
                )}
            </div>
            {presetNameLabel && (
                <div
                    style={{ overflowWrap: 'break-word' }}
                    title={presetNameLabel}
                    className="bg-bgBackground text-center font-xs font-medium text-purpleFont absolute bottom-16 w-[85%] left-[50%] translate-x-[-50%] rounded p-2"
                >
                    {formatString(presetNameLabel, 40)}
                </div>
            )}
            {!disablePresetFilter && (
                <div className="w-36 pt-2 absolute bottom-4 left-[50%] translate-x-[-50%]">
                    <CancelButton className="w-full" disabled={isFilterEmpty} onClick={() => onSaveSelection()}>
                        Save Selection
                    </CancelButton>
                </div>
            )}
        </div>
    );
}

export default FilterExpand;
